import { API_PREFIX } from "./api.constants";

export type ProficiencyKind = 'competency' | 'skill';

const BASE: Record<ProficiencyKind, string> = {
  competency: `${API_PREFIX}/competences`,
  skill: `${API_PREFIX}/skills`,
};

export const PROFICIENCY_ENDPOINTS = {
  MY_STATUS: (kind: ProficiencyKind) => `${BASE[kind]}/status/my`,
  USER_STATUS: (kind: ProficiencyKind, userId: number | string) =>
    `${BASE[kind]}/status/users/${userId}`,
  RATINGS: (kind: ProficiencyKind, entityId: number | string, userId: number | string) =>
    `${BASE[kind]}/${entityId}/users/${userId}/ratings`,
  ASSESSORS: (kind: ProficiencyKind, entityId: number | string) =>
    `${BASE[kind]}/${entityId}/assessors`,
  LINKED_COURSES: (kind: ProficiencyKind, entityId: number | string) =>
    `${BASE[kind]}/${entityId}/courses`,
  POSITION_READINESS: (kind: ProficiencyKind, positionId: number | string) =>
    `${BASE[kind]}/positions/${positionId}/readiness`,
};
